import React from "react";

import { IInstantNotifier } from "./types";


export const InstantNotifierContext = React.createContext<IInstantNotifier | null>(null);

const InstantNotifierProvider : React.FC<{service: IInstantNotifier, children: React.ReactNode}> = ({ service, children }) => {

    return (
        <InstantNotifierContext.Provider value={service}>
          {children}
        </InstantNotifierContext.Provider>
    );
};

export default InstantNotifierProvider;